<template>
  <div class="flex gap-8 place-content-between">
    <div class="flex flex-col gap-8">
      <p class="heading-xxs">
        {{ productName }}
      </p>
      <p v-if="dataAllowance">
        <span
          v-if="
            regularDataAllowance && regularDataAllowance * 2 === dataAllowance
          "
          class="strike-through text-text-secondary"
          aria-hidden="true"
        >
          {{ regularDataAllowance }}
        </span>
        {{ dataAllowance }} GB
      </p>
      <p v-if="productInfo">{{ productInfo }}</p>
    </div>
    <div class="flex flex-row gap-8">
      <p>
        <span
          v-if="regPrice && regPrice !== price"
          class="strike-through text-text-secondary"
        >
          {{ regPrice }}
        </span>
      </p>
      <p class="heading-xxs">{{ price }} {{ priceUnit }}</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
type Props = {
  productName?: string;
  productInfo?: string;
  regPrice?: string;
  price?: string;
  priceUnit?: string;
  dataAllowance?: number;
  regularDataAllowance?: number;
};
withDefaults(defineProps<Props>(), {
  productName: '',
  productInfo: '',
  regPrice: '',
  price: '',
  priceUnit: '',
  dataAllowance: undefined,
  regularDataAllowance: undefined,
});
</script>
